import { Restaurant, Dish, Pack } from '../types';

export const MOCK_RESTAURANTS_SEED = [
    {
        id: "seed_resto_1",
        name: "L'Arôme du Maghreb",
        description: "Une cuisine traditionnelle raffinée au cœur d'Alger. Découvrez nos saveurs authentiques.",
        slogan: "Le goût de l'authenticité",
        image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=800",
        rating: 4.8,
        ratingCount: 156,
        deliveryTime: "25-35 min",
        minOrder: 1500,
        categories: ["Traditionnel", "Plats"],
        ownerId: "seed_owner_1",
        wilaya: "Alger",
        status: "approved",
        subscriptionStatus: "active",
        subscriptionType: "mensuel",
        isOnline: true,
        deliveryEnabled: true,
        deliveryPrice: 300,
        featured: true,
        globalDiscount: 10,
        location: { lat: 36.7538, lng: 3.0588 },
        menu: [], // To be populated
        packs: []
    },
    {
        id: "seed_resto_2",
        name: "Burger Station",
        description: "Les meilleurs burgers gourmets de la ville préparés avec des produits frais.",
        slogan: "Vrai Burger, Vrai Plaisir",
        image: "https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=800",
        rating: 4.5,
        ratingCount: 89,
        deliveryTime: "20-30 min",
        minOrder: 1200,
        categories: ["Burgers", "Fast Food"],
        ownerId: "seed_owner_2",
        wilaya: "Alger",
        status: "approved",
        subscriptionStatus: "active",
        subscriptionType: "mensuel",
        isOnline: true,
        deliveryEnabled: true,
        deliveryPrice: 200,
        location: { lat: 36.7372, lng: 3.0857 },
        menu: [],
        packs: []
    },
    {
        id: "seed_resto_3",
        name: "Pizza Napoli",
        description: "Véritable pizza au feu de bois avec une pâte artisanale et des ingrédients importés.",
        slogan: "L'Italie dans votre assiette",
        image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800",
        rating: 4.9,
        ratingCount: 243,
        deliveryTime: "30-45 min",
        minOrder: 1800,
        categories: ["Pizzas", "Italien"],
        ownerId: "seed_owner_3",
        wilaya: "Oran",
        status: "approved",
        subscriptionStatus: "active",
        subscriptionType: "annuel",
        isOnline: true,
        deliveryEnabled: true,
        deliveryPrice: 250,
        location: { lat: 35.6987, lng: -0.6358 },
        menu: [],
        packs: []
    }
];

export const MOCK_DISHES_SEED: Record<string, any[]> = {
    "seed_resto_1": [
        {
            name: "Couscous Royal",
            description: "Semoule fine, légumes frais, agneau tendre, merguez et poulet.",
            price: 1800,
            image: "https://images.unsplash.com/photo-1541518763669-27fef04b14ea?w=600",
            category: "Traditionnel",
            available: true,
            discount: 0
        },
        {
            name: "Tajine d'Agneau aux Pruneaux",
            description: "Plat mijoté avec des pruneaux, amandes grillées et cannelle.",
            price: 2200,
            image: "https://images.unsplash.com/photo-1541014741259-df549fa9ba6f?w=600",
            category: "Traditionnel",
            available: true,
            discount: 15
        }
    ],
    "seed_resto_2": [
        {
            name: "The Classic Cheese",
            description: "Bœuf 150g, cheddar, salade, tomate, oignons caramélisés.",
            price: 950,
            image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=600",
            category: "Burgers",
            available: true
        },
        {
            name: "Bacon Crisis",
            description: "Bœuf, double bacon, œuf au plat, sauce BBQ fumée.",
            price: 1250,
            image: "https://images.unsplash.com/photo-1553979459-d2229ba7433b?w=600",
            category: "Burgers",
            available: true
        }
    ],
    "seed_resto_3": [
        {
            name: "Margherita D.O.C",
            description: "Tomate San Marzano, mozzarella di bufala, basilic frais.",
            price: 1300,
            image: "https://images.unsplash.com/photo-1574071318508-1cdbad80ad38?w=600",
            category: "Pizzas",
            available: true
        },
        {
            name: "Quattro Stagioni",
            description: "Tomates, mozzarella, artichauts, champignons, olives, jambon de dinde.",
            price: 1600,
            image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=600",
            category: "Pizzas",
            available: true
        }
    ]
};

export const MOCK_PACKS_SEED: Record<string, any[]> = {
    "seed_resto_1": [
        {
            name: "Pack Famille Tradition",
            description: "2 Couscous au choix + 1 Chorba Offerte + Boisson 1.5L",
            originalPrice: 5000,
            packPrice: 4200,
            dishes: [
                { id: "p1_d1", name: "Couscous Royal", category: "Traditionnel", price: 1800, quantity: 2 },
                { id: "p1_d2", name: "Chorba", category: "Traditionnel", price: 800, quantity: 1 }
            ],
            image: "https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?w=600",
            available: true
        }
    ],
    "seed_resto_2": [
        {
            name: "Combo Duo Burger",
            description: "2 Burgers au choix + 2 Frites + 2 Boissons",
            originalPrice: 3500,
            packPrice: 2800,
            dishes: [
                { id: "p2_d1", name: "The Classic Cheese", category: "Burgers", price: 950, quantity: 2 }
            ],
            image: "https://images.unsplash.com/photo-1594970544554-7bb2a98b4b3f?w=600",
            available: true
        }
    ]
};

export const MOCK_USERS_SEED = [
    {
        uid: "seed_admin_1",
        email: "amine@gmail.com",
        name: "Amine Admin",
        role: "super_admin",
        wilaya: "Alger"
    },
    {
        uid: "seed_owner_1",
        email: "owner1@yumii.dz",
        name: "Chef Ahmed",
        role: "restaurateur",
        restaurantId: "seed_resto_1",
        restaurantStatus: "approved",
        wilaya: "Alger"
    },
    {
        uid: "seed_driver_1",
        email: "driver1@yumii.dz",
        name: "Yassine Livreur",
        role: "livreur",
        wilaya: "Alger",
        isOnline: true,
        livreurStatus: "approved",
        rating: 4.9,
        ratingCount: 42
    },
    {
        uid: "seed_client_1",
        email: "client@yumii.dz",
        name: "Mohamed Client",
        role: "client",
        wilaya: "Alger"
    }
];
